import { useEffect, useState } from "react";

export default function useIsSectionMobile(breakpoint = 1400) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => {
      const w = window.innerWidth || 0;
      setIsMobile(w <= breakpoint);
    };

    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [breakpoint]);

  return isMobile;
}
